export default __webpack_public_path__ + "static/media/2_phones.1d027c9b.png";